const parentescos = {
    '01': 'PAI',
    '20008': 'PADRASTO',
    '02': 'MAE',
    '20007': 'MADRASTA',
    '10': 'ESPOSO(A)',
    '32': 'EX-CONJUGE',
    '15': 'SOGRO(A)',
    '5': 'FILHO(A)',
    '50': 'FILHO(A) ADOTIVO',
    '03': 'IRMA(O)',
    '07': 'SOBRINHO(A)',
    '10006': 'ENTEADO(A)',
    '10016': 'OUTROS',
    '12': 'NETO(A)',
    '22': 'PRIMO(A)',
    '19': 'GENRO',
    '20': 'NORA',
    '24': 'TIO(A)',
    'AVô': 'AVO',
    'PET': 'PET (ANIMAL)'
};

export const grausEquivalentes = {
    '01': '20008',
    '20008': '01',

    '02': '20007',
    '20007': '02',

    '10': '32',
    '32': '10'
};

const verificaSeJaPossuiParentescoSelecionado = (dependentes, values) =>{
    const seq = values.Seq;
    const parentesco = values.Parentesco;
    const parentescosQuePodemSerMaisQueUm =['5','50','03','07','10006','10016','22','12','20','19','24'];

    if(!parentesco){
        return false;
    }

    if(parentescosQuePodemSerMaisQueUm.includes(parentesco.trim())){
        return false;
    }

    const possuiParentescoSelecionado = dependentes.filter(dependente => dependente['GrauParentesco.Grau'].trim() === parentesco.trim());

    if(!possuiParentescoSelecionado.length){
        const grausEquivalente = grausEquivalentes[`${parentesco.trim()}`];

        const possuiParentescoEquivalente = dependentes.filter(dependente => dependente['GrauParentesco.Grau'].trim() === grausEquivalente );

        return possuiParentescoEquivalente.length ? seq ? seq !== possuiParentescoEquivalente[0].Seq : true : false;
    }

    if(parentesco.trim() === '15'){
        return possuiParentescoSelecionado.length === 2? true : false;
    }

    if(parentesco.trim() === 'AVô'){
        return possuiParentescoSelecionado.length === 4? true : false;
    }

    if(seq){
        return seq !== possuiParentescoSelecionado[0].Seq;
    }

    return true;
};

export const calcularQtdDependentesConjuge = dependentes => {
    const dependentesConjuge = dependentes.filter(
        dependente => dependente['GrauParentesco.Grau'].trim() === '10'
    );

    return dependentesConjuge;
};

export const validatorAte64Anos = valoresForm =>{
    const arrayDeValidacoes = [

        idadeAte64(valoresForm.Idade),
        verificarIdadePreenchida(valoresForm.Idade),
        verificarCategoriaPrenchida(valoresForm.Categoria),
        verificarAdicionalAte64(valoresForm.Categoria)
    ];

    return arrayDeValidacoes.every(validacao => validacao === true);
};

export const validatorMaiorIgual65Anos = valoresForm =>{
    const arrayDeValidacoes = [

        idadeAte65(valoresForm.Idade),
        verificarIdadePreenchida(valoresForm.Idade),
        verificarCategoriaPrenchida(valoresForm.Categoria),
        verificarAdicionalAte65(valoresForm.Categoria)
    ];

    return arrayDeValidacoes.every(validacao => validacao === true);
};

export const validatorParentescoEmDuplicidade = (valoresForm,dependentes) =>{
    const arrayDeValidacoes = [
        verificaSeJaPossuiParentescoSelecionado(dependentes, valoresForm)
    ];

    return arrayDeValidacoes.every(validacao => validacao === true);
};

const verificarIdadePreenchida = idade => idade !== '' && idade !== null;
const verificarCategoriaPrenchida = categoria => categoria !== '';
const verificarSemAdicional = categoria => categoria.trim() === 'ZELO';
const verificarAdicionalAte64 = categoria => categoria.trim() !== 'ZMA64';
const verificarAdicionalAte65 = categoria => categoria.trim() !== 'ZMM65';
const idadeAte64 = idade => idade <= 64;
const idadeAte65 = idade => idade >= 65;

export const retornaLabelDoValorParentesco = valueParentesco => {
    const parentesco = valueParentesco.trim();
    const grauEquivalente = grausEquivalentes[parentesco];

    if(parentesco === '15' || parentesco === '10006'){
        return `Só é permitido dois dependentes do tipo  ${parentescos[`${parentesco}`]}`;
    }

    if(parentesco === 'AVô'){
        return `Só é permitido quatro dependentes do tipo  ${parentescos[`${parentesco}`]}`;
    }

    return `Só é permitido um dependente do tipo  ${parentescos[`${parentesco}`]} / ${parentescos[`${grauEquivalente}`]}`;
};
